/* eslint-disable no-useless-escape */
import { api } from '../api';

const getFileNameFromContentDisposition = (contentDisposition) => {
    if (!contentDisposition || typeof contentDisposition !== 'string') return undefined;

    // RFC 5987: filename*=UTF-8''encoded
    const filenameStarMatch = contentDisposition.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
    if (filenameStarMatch?.[1]) {
        try {
            return decodeURIComponent(filenameStarMatch[1]);
        } catch (_e) {
            return filenameStarMatch[1];
        }
    }

    const filenameMatch = contentDisposition.match(/filename\s*=\s*\"?([^\";]+)\"?/i);
    return filenameMatch?.[1];
};

export const timeAuditReport = api.injectEndpoints({
    endpoints: (builder) => ({
        getTimeAuditReports: builder.query({
            query: (payload) => ({
                url: 'api/report/therapy-session-time-comparison-report/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'list'
                }
            })
        }),
        getPrintTimeAuditReports: builder.query({
            query: (payload) => ({
                url: 'api/report/therapy-session-time-comparison-report/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'list'
                },
                responseHandler: (res) =>
                    res.blob().then((blob) => ({
                        blob,
                        fileName: getFileNameFromContentDisposition(res.headers.get('content-disposition')),
                        type: res.headers.get('content-type')
                    }))
            })
        })
    })
});

export const { useLazyGetTimeAuditReportsQuery, useLazyGetPrintTimeAuditReportsQuery } = timeAuditReport;
